import { SvgIcon } from '@material-ui/core';

interface WarningIconProps {
  color?: string;
}

export const WarningIcon = ({ color = 'currentColor' }: WarningIconProps) => (
  <SvgIcon viewBox="0 0 24 24" style={{ color }}>
    <path
      d="M1 21h22L12 2 1 21z"
      fill="none"
      stroke={color === 'currentColor' ? 'currentColor' : color}
      strokeWidth="1.5"
    />
    <rect
      x="11"
      y="10"
      width="2"
      height="5"
      fill={color === 'currentColor' ? 'currentColor' : color}
    />
    <rect
      x="11"
      y="16"
      width="2"
      height="2"
      fill={color === 'currentColor' ? 'currentColor' : color}
    />
  </SvgIcon>
);
